import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormError } from './hook-form-error';
import useDebouncedValidation from '../../hooks/use-debounced-hookform-validation';
import { QueryKeyConfig } from '../../api/api-helper';
import { LoadingIndicator } from '../loading-indicator.component';

interface InputFieldProps {
  label?: string;
  placeHolder?: string;
  name: string;
  maxLength?: number;
  size?: number;
  multiline?: boolean;
  type?: string;
  autoFocus?: boolean;
  onBlur?: any;
  onChange?: any;
  disabled?: boolean;
  isShrink?: boolean;
  isValidateOnChange?: boolean;
  validationQueryRoute?: (value: any) => QueryKeyConfig;
  className?: string;
  required?: boolean;
  styleField?: any
  isCustomError?: boolean;
  isParentLoading?: boolean;
}

export const FormInput = ({
  name,
  label,
  size,
  multiline,
  type,
  onBlur,
  onChange,
  disabled,
  isShrink,
  isValidateOnChange,
  validationQueryRoute,
  className,
  required,
  styleField,
  isCustomError,
  isParentLoading,
}: InputFieldProps): any => {
  const { formState: { errors }, control } = useFormContext();
  const { validate, isLoading } = useDebouncedValidation({ name, validationQueryRoute });

  function getErrorMessage(error: any, propertyPath: string) {
    const pathArray = propertyPath.split('.');
    let currentError = error;
    for (const path of pathArray) {
      currentError = currentError && currentError[path];
      if (!currentError) {
        return null;
      }
    }
    return currentError.message || null;
  }

  const [value, setValue] = useState('');

  const handleChange = (val: any) => {
    setValue(val);
    onChange(val);
    const message = Boolean(getErrorMessage(errors, name))
    if (!isValidateOnChange) {
      if (isCustomError) {
        if (!message)
          validate(val);
      }
      else {
        validate(val);
      }
    }
  };

  const handleOnBlur = (val: any) => {
    const message = Boolean(getErrorMessage(errors, name))
    if (isCustomError) {
      if (!message)
        validate(val);
    }
    else {
      validate(val);
    }
    onBlur(val);
  };

  return (
    <div className="form-group">
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            <LoadingIndicator isLoading={isLoading || isParentLoading} />
            <TextField
              name={name}
              label={label}
              variant="outlined"
              size="small"
              fullWidth
              multiline={multiline}
              rows={size ? size : 4}
              style={styleField}
              onBlur={(e) => {
                //  onBlur(); validation disappearing on focus out
                handleOnBlur(e.target.value);
              }}
              onChange={(e) => {
                onChange(e);
                handleChange(e.target.value);
              }}
              type={type}
              value={value}
              disabled={disabled}
              InputLabelProps={{
                shrink: !isShrink ? undefined : isShrink,
              }}
              InputProps={{
                inputProps: {
                  step: 'any',
                  min: 0,
                },
              }}
              className={`${className} ${required ? 'itsarequiredField' : ''} ${value ? 'has-data' : ''}`}
            />
          </>
        )}
      />
      <FormError name={name} />
    </div>
  );
};

FormInput.defaultProps = {
  label: undefined,
  maxLength: undefined,
  placeHolder: undefined,
  onBlur: () => {
    return;
  },
  onChange: () => {
    return;
  },
};

export default FormInput;
